import logo from "assets/img/logo/logo_aig_login-2.png";
import PropTypes from "prop-types";
import React from "react";
import { Button, Label, Alert } from "reactstrap";
import Iframe from "react-iframe";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { actualizarDisclaimerFecth } from "../../redux/actions/aRamos";
import { encriptarTrama } from "../../utils/Encriptar";
import LoadingScreen from "react-loading-screen";
import { Checkbox } from "react-inputs-validation";

class ActualizarDisclaimer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAgreementChecked: false,
      disabledButton: true
    };
  }
  get isLogin() {
    return this.props.authState === STATE_LOGIN;
  }

  changeAuthState = authState => event => {
    event.preventDefault();

    this.props.onChangeAuthState(authState);
  };

  handleSubmit = event => {
    event.preventDefault();
  };

  handleAccept = () => {
    this.onSelectActualizarDisclaimer();
  };

  onSelectActualizarDisclaimer() {
    let datadisclaimer = {};
    datadisclaimer = {
      cliCodigoCore: this.props.usuario.cliCodigoCore,
      disclaimerVer: true
    };
    datadisclaimer = JSON.stringify(datadisclaimer);
    let encrypted64Login = encriptarTrama(datadisclaimer);
    this.props.onSelectActualizarDisclaimer(encrypted64Login);
    this.props.history.replace("/principal");
    /*this.props.history.replace({
      pathname: "/cotizacion",
      search: `?accion=nuevo`
    });// Para ir a la pantalla de ramos y no permitirle regresar mediante el navegador*/
  }

  render() {
    const renderStatus = () => {
      const { showLogo } = this.props;
      let isLoading = !this.props.disclaimer.disclaimerLoading ? false : this.props.disclaimer.disclaimerLoading;
      const { isAgreementChecked, agreement, disabledButton } = this.state;
      return (
        <LoadingScreen
          loading={isLoading}
          bgColor="#f1f1f1"
          spinnerColor="#001871"
          textColor="#676767"
          logoSrc={logo}
          text="Guardando información"
        >
          <form onSubmit={this.handleSubmit}>
            {showLogo && (
              <div className="text-center pb-4">
                <img src={logo} className="login-logo" style={{ cursor: "pointer" }} alt="logo" />
              </div>
            )}

            <Iframe
              url={this.props.usuario.disclaimerUrl}
              height="450vh"
              width="80%"
              id="myId"
              className="data-fast"
              display="block"
              position="relative"
              margin="auto"
              allowFullScreen
              styles={{ fontFamily: "sans-serif", height: "75vh" }}
              async={true}
            />
            <br></br>
            <hr />
            <div>
              <Checkbox
                id={"agreement"} // Optional.[String].Default: "".  Input ID.
                name={"agreement"} // Optional.[String].Default: "". Input name
                value={agreement} // Required.[String].Default: "".
                onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                checked={isAgreementChecked} // Required.[Bool].Default: false.
                classNameContainer="center-check"
                onChange={(isAgreementChecked, e) => this.setState({ isAgreementChecked, disabledButton: !isAgreementChecked })}
                //console.log(e);
                // Required.[Func].Default: () => {}. Will return the value.
                labelHtml={
                  <div style={{ color: "#4a4a4a", marginTop: "2px", margin: "auto", marginBottom: "-6px" }} >
                    He leído y acepto los términos y condiciones
                  </div>
                } // Required.[Html].Default: none.
                validationOption={{
                  name: "agreement", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                  check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                  required: true // Optional.[Bool].Default: true. To determin if it is a required field.
                }}
              />

              <div className="text-center pb-4">
                <div className="tit_aceptar_edad text-center" />
                <br />
                <Button className="btn btn-primary" onClick={this.handleAccept} disabled={disabledButton} size="lg" > ACEPTAR </Button>
              </div>
            </div>

          </form>
        </LoadingScreen>
      );
    };
    return renderStatus();
  }
}

export const STATE_LOGIN = "LOGIN";

ActualizarDisclaimer.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN]).isRequired,
  onSelectActualizarDisclaimer: PropTypes.func,
  showLogo: PropTypes.bool
};

ActualizarDisclaimer.defaultProps = {
  authState: "LOGIN",
  showLogo: true
};

const mapStateToProps = state => ({
  usuario: state.datosUsuarios.dataUsuario,
  disclaimer: state.datosActualizarDisclaimer
});

const mapDispatchToProps = dispatch => {
  return {
    onSelectActualizarDisclaimer: datadisclaimer =>
      dispatch(actualizarDisclaimerFecth(datadisclaimer))
  };
};

//export default ActualizarDisclaimer;
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ActualizarDisclaimer)
);
